import { Icon, Popup } from 'semantic-ui-react'
import Image from 'next/image'
import YC from '@assets/yc.png'
import DigitalNomad from '@assets/digitalnomad'
import styles from './style.module.css'

export default function Tag({
  standardWidth,
  color,
  icon,
  text = '',
  blackwhite = true,
  doNotTrim,
}) {
  let clr

  switch (color) {
    case 'green':
      clr = '#21ba45'
      break
    case 'orange':
      clr = '#f2711c'
      break
    case 'teal':
      clr = '#00b5ad'
      break
    case 'black':
      clr = '#1b1c1d'
      break
    default:
      clr = '#767676'
  }

  if (blackwhite) {
    clr = '#0000ffff'
  }

  let style = {
    width: 'unset',
  }

  if (standardWidth) {
    style.width = '160px'
  }

  const trimmedText = doNotTrim ? text : text.split(',')[0]

  const renderIcon = () => {
    if (icon === 'YC') {
      return (
        <div style={{ position: 'relative', top: '2px' }}>
          <Popup
            content="This startup is backed by YC"
            on="hover"
            position="right center"
            trigger={
              <Image
                width={16}
                height={16}
                src={YC}
                alt="YCombinator backed company"
              />
            }
          />
        </div>
      )
    }

    if (blackwhite) {
      return <Icon name={icon} color={color} />
    }
    return <Icon name={icon} />
  }

  return (
    <div
      className={`${styles.tag} ${blackwhite ? styles.blackwhite : ''}`}
      style={style}
    >
      <div className={styles.tagIconContainer}>{renderIcon()}</div>
      <div className={styles.tagTextContainer}>{trimmedText}</div>
    </div>
  )
}
